/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcClearingV1ClosingPositionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_CLEARING_V1_CLOSING_POSITION_EVENT_ENTITY_NAME = 'ixc.clearing.v1.ClosingPositionEvent';
export const ixcClearingV1ClosingPositionEventEntity = new schema.Entity<IxcClearingV1ClosingPositionEvent>(IXC_CLEARING_V1_CLOSING_POSITION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcClearingV1ClosingPositionEvent) => `${entity.metadata?.eventId}` });

